module.exports = __webpack_public_path__ + "static/media/back-arrow.b4be76ed.svg";